// Package imports:
import React from "react";
import { Form, useFormikContext } from "formik";
// Component imports:
import Radio from "../../../ui-elements/Radio/Radio";
import Input from "../../../ui-elements/Input/Formik/Input";
// Type imports:
import { RiskScoreFormValues } from "../../../types/DueDiligenceTypes";
import Button from "../../../ui-elements/Button/Button";

interface IProps {
    values: RiskScoreFormValues;
    closeModal(): void;
    disableSubmit: boolean;
}

export const RiskScoreForm: React.FC<IProps> = ({
    values,
    closeModal,
    disableSubmit
}) => {
    const { setFieldValue } = useFormikContext<RiskScoreFormValues>();

    return (
        <Form>
            <div className="form__body">
                <div className="form__row">
                    <div className="form__col">
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio
                                        id="low"
                                        name="low"
                                        value="Lítil áhætta"
                                        defaultValue={values.riskScore ?? ''}
                                        onChange={(e) => setFieldValue("riskScore", e.target.value)}
                                    >
                                        Lítil áhætta
                                    </Radio>
                                </li>
                                <li>
                                    <Radio
                                        id="medium"
                                        name="medium"
                                        value="Meðal áhætta"
                                        defaultValue={values.riskScore ?? ''}
                                        onChange={(e) => setFieldValue("riskScore", e.target.value)}
                                    >
                                        Meðal áhætta
                                    </Radio>
                                </li>
                                <li>
                                    <Radio
                                        id="high"
                                        name="high"
                                        value="Mikil áhætta"
                                        defaultValue={values.riskScore ?? ''}
                                        onChange={(e) => setFieldValue("riskScore", e.target.value)}
                                    >
                                        Mikil áhætta
                                    </Radio>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="form__row">
                    <div className="form__col">
                        <Input
                            label="Athugasemdir"
                            name="description"
                            id="description"
                            value={values.description}
                            inputType="textArea"
                        />
                    </div>
                </div>
            </div>
            <div className="form__actions">
                <Button
                    type="button"
                    buttonType="secondary"
                    size="lg"
                    onClick={closeModal}
                >
                    Hætta við
                </Button>
                <Button
                    type="submit"
                    buttonType="primary"
                    size="lg"
                    disabled={disableSubmit}
                >
                    Staðfesta
                </Button>
            </div>
        </Form>
    )
}